"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Upgrade/OrgLimitNotice.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _upgrade = require('shared/enum/upgrade');
var _upgradeNotices = require('shared/constants/upgradeNotices');
var _user = require('shared/selectors/user');
var _org = require('shared/selectors/org');

var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _UpgradeModal = require('web/components/Upgrade/UpgradeModal'); var _UpgradeModal2 = _interopRequireDefault(_UpgradeModal);
var _Form = require('web/components/Form');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _hooks = require('web/services/hooks');







const OrgLimitNotice = ({
  orgKey,
  className,
  addedUsersCount = 0,
}) => {
  const amIAdmin = _hooks.useAppSelector.call(void 0, state => _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const availableSeats = _hooks.useAppSelector.call(void 0, state => _org.selectAvailableMemberSeatsInOrg.call(void 0, state, orgKey))
  const {
    isOpen: isUpgradeModalOpen,
    onOpen: onOpenUpgradeModal,
    onClose: onCloseUpgradeModal,
  } = _useToggle2.default.call(void 0, )

  const canReachLimit = addedUsersCount > 0
    && availableSeats >= 0
    && addedUsersCount > availableSeats
  if (!amIAdmin || !canReachLimit) return null

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, "org-limit-warning", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
      , _react2.default.createElement('div', { className: "org-limit-warning--info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
        , _react2.default.createElement('span', { className: "org-limit-warning--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
          ,  _upgradeNotices.soonToHitLimitNotice 
        )
      )
      , _react2.default.createElement(_Form.Button, {
        isSecondary: true,
        onClick: onOpenUpgradeModal,
        className: "org-limit-warning--btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
, "Upgrade"

      )
        , _react2.default.createElement(_UpgradeModal2.default, {
          isOpen: isUpgradeModalOpen,
          onClose: onCloseUpgradeModal,
          type: _upgrade.SubscriptionItemType.TEAM,
          orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
        )
    )
  )
}

exports. default = _react.memo.call(void 0, OrgLimitNotice)
